// Story saas-1.18 (D10): shared filename sanitization util.
// Extracted from lib/csv/csvExporter.ts so that markdown/csv/pdf exporters
// produce identical filename slugs.

export function sanitizeFilenameTitle(title: string | undefined): string {
  const base = (title || 'formulario').trim();
  return (
    base
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '') // strip combining diacriticals (accents)
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '_')
      .slice(0, 60) || 'formulario'
  );
}
